// @flow
import React, { memo } from 'react'
import styled from 'styled-components'

const Value = ({
    fontSize,
    unitFontColor,
    valueFontColor,
    align,
    value,
    valueBold,
    unitBold,
    valueItalic,
    unitItalic,
    unitProportion,
    uom
}: ValueProps) => (
    <ValueContainer className="dark-color-adaptive-container" align={align}>
        <ValueDisplay fontSize={fontSize} bold={valueBold} italic={valueItalic} fontColor={valueFontColor}>
            {typeof value != 'undefined' ? `${value}` : <i className="fal fa-question-circle" />}
        </ValueDisplay>
        <ValueDisplay
            fontSize={(fontSize * unitProportion) / 100}
            bold={unitBold}
            italic={unitItalic}
            fontColor={unitFontColor}
        >
            {` ${uom || ''}`}
        </ValueDisplay>
    </ValueContainer>
)

const ValueDisplay = styled.span`
    display: inline-block;
    font-size: ${props => props.fontSize}px;
    line-height: ${props => props.fontSize}px;
    ${({ bold, theme }) => (bold ? `font-family: ${theme['font-semibold']}` : '')};
    ${props => (props.italic ? 'font-style: italic' : '')};
    ${props => (props.fontColor ? `color: ${props.fontColor}` : '')};
`

function align(align: string) {
    switch (align) {
        case 'left':
            return 'flex-start'
        case 'right':
            return 'flex-end'
        case 'center':
        default:
            return 'center'
    }
}

const ValueContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: baseline;
    justify-content: ${props => align(props.align)};
`

export default memo(Value)
